import { useEffect, useState } from 'react';
import { homeNavItems } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#top" className="flex items-center gap-3 cursor-pointer">
            <span
              className={`w-9 h-9 flex items-center justify-center rounded-md transition-colors ${
                scrolled ? 'bg-primary-500 text-background-50' : 'bg-background-50/90 text-primary-600'
              }`}
            >
              <i className="ri-archive-2-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-lg font-bold tracking-wide transition-colors ${
                  scrolled ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                网红黑料
              </span>
              <span
                className={`text-[11px] tracking-[0.2em] mt-1 transition-colors ${
                  scrolled ? 'text-foreground-500' : 'text-background-200'
                }`}
              >
                实锤 · 原视频 · 录屏 归档
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {homeNavItems.map((item) => (
              <a
                key={item.id}
                href={item.href}
                className={`text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-100 hover:text-accent-300'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="#submit"
              className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-add-line"></i>
              提交线索
            </a>
          </div>

          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((prev) => !prev)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
              scrolled ? 'text-foreground-900 bg-background-100' : 'text-background-50 bg-foreground-950/30'
            }`}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-b border-background-200">
          <nav className="px-4 py-4 flex flex-col gap-1">
            {homeNavItems.map((item) => (
              <a
                key={item.id}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-4 py-3 rounded-md text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 h-11 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              <i className="ri-add-line"></i>
              提交线索
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}